module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-info"
  }, [_c('div', {
    staticClass: "hour"
  }, [_vm._v("\n    " + _vm._s(_vm.time) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "account-card"
  }, [_c('div', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "identity-row"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.trainer.firstName))]), _vm._v(" "), _c('span', {
    staticClass: "role-pill"
  }, [_vm._v(_vm._s(_vm.roleLabel))])]), _vm._v(" "), _c('button', {
    staticClass: "logout",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('svg', {
    staticClass: "logout-icon",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10 17l5-5-5-5"
    }
  }), _c('path', {
    attrs: {
      "d": "M15 12H3"
    }
  }), _c('path', {
    attrs: {
      "d": "M21 19V5a2 2 0 0 0-2-2h-5"
    }
  }), _c('path', {
    attrs: {
      "d": "M14 21h5a2 2 0 0 0 2-2"
    }
  })]), _vm._v("\n        Log out\n      ")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.userPicture,
      "alt": "User Picture"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-98e3e1e2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppHeader/UserInfo.vue
// module id = 1744
// module chunks = 2